import { SessionStorageService } from './session-storage';
import { REFERRED_PROVIDER_QUERY } from '@/util/constants';
import { useSearchParams } from '@/util/react-router-dom';
import { useEffect } from 'react';

const REFERRAL_ID_KEY = 'referral-id';

const storage = new SessionStorageService<number>(REFERRAL_ID_KEY);

export class ReferralStorage {
  get referralId() {
    return storage.data;
  }

  saveReferralId(id: number) {
    storage.save(id);
  }

  remove() {
    storage.remove();
  }
}

const referralStorage = new ReferralStorage();

export function useReferralCapture() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const referral = searchParams.get(REFERRED_PROVIDER_QUERY);
    if (referral && !isNaN(Number(referral))) {
      referralStorage.saveReferralId(Number(referral));
    }
  }, [searchParams]);
}
